import { render, staticRenderFns } from "./Criar-Diario.vue?vue&type=template&id=5aa8f56b&"
import script from "./Criar-Diario.vue?vue&type=script&lang=js&"
export * from "./Criar-Diario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Criar-Diario.vue"
export default component.exports